import { SIDEMENU } from './toggle'

const initialState = {
  display:               false,
  displayFilters:        false,
  displayCreation:       false,
  displayProfiles:       false,
  displayAdvancedSearch: false
}

export default function sideMenuReducer(state = initialState, action) {
  switch (action.type) {

  case SIDEMENU.TOGGLE:
    return SIDEMENU
      .toggleResponse({
        state:  initialState,
        active: !state.display
      })

  case SIDEMENU.TOGGLE_FILTERS:
    return SIDEMENU
      .toggleFiltersResponse({
        state:  initialState,
        active: !state.displayFilters
      })

  case SIDEMENU.TOGGLE_CREATION:
    return SIDEMENU
      .toggleCreationResponse({
        state:  initialState,
        active: !state.displayCreation
      })

  case SIDEMENU.TOGGLE_PROFILES:
    return SIDEMENU
      .toggleProfilesResponse({
        state:  initialState,
        active: !state.displayProfiles
      })

  case SIDEMENU.TOGGLE_ADVANCED_SEARCH:
    return SIDEMENU
      .toggleAdvancedSearchResponse({
        state:  initialState,
        active: !state.displayAdvancedSearch
      })

  default:
    return state
  }
}
